var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", disabled: _vm.unableModify },
                  on: {
                    click: function($event) {
                      return _vm.showAddPlanDialog()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(" " + _vm._s(_vm.$t("pricingPlan")) + " ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs4: "", md2: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "filter_list",
                  label: _vm.$t("search"),
                  "single-line": "",
                  "hide-details": "",
                  clearable: ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.warehousePricingPlans || [],
          "hide-actions": "",
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(item.name))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "white-space": "pre-line",
                        "word-break": "break-word",
                        overflow: "hidden",
                        display: "-webkit-box",
                        "-webkit-box-orient": "vertical",
                        "-webkit-line-clamp": "6",
                        "text-overflow": "ellipsis"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            item.upcs
                              .map(function(upcItem, index) {
                                return (
                                  "" +
                                  (index !== 0 && index % 3 === 0
                                    ? upcItem.upc + "\n"
                                    : index === item.upcs.length - 1
                                    ? upcItem.upc
                                    : upcItem.upc + "     |     ")
                                )
                              })
                              .join("")
                          ) +
                          "\n        "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-xs-left" }, [
                  _vm._v(_vm._s(_vm.toDateYYYYMMDD(item.createTime)))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "text-xs-left",
                    staticStyle: {
                      "white-space": "pre-line",
                      "word-break": "break-word",
                      "max-width": "300px"
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item.note) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", icon: "", flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.showAddPlanDialog(item, true)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("content_copy")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", icon: "", flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.showAddPlanDialog(item)
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("edit")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: _vm.unableModify,
                                  color: "primary",
                                  icon: "",
                                  flat: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deletePricingPlan(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { color: "red" } }, [
                                  _vm._v("cancel")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.title,
          rightButtonDisabled:
            _vm.pricingPlan.upcs.some(function(item) {
              return !item.upc || item.editMode
            }) || _vm.unableModify,
          rightMethod: _vm.savePricingPlan,
          large: ""
        },
        on: {
          popupClose: function($event) {
            return _vm.close()
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-container",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", warp: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { md3: "" } },
                          [
                            !_vm.pricingPlan.key
                              ? _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t("name"),
                                    rules: [
                                      _vm.fieldIsRequired("name"),
                                      function(value) {
                                        return _vm.isPricingPlanNameDup(
                                          (value || "").trim()
                                        )
                                      }
                                    ]
                                  },
                                  model: {
                                    value: _vm.pricingPlan.name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pricingPlan,
                                        "name",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "pricingPlan.name"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs2: "" } }),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs2: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("inboundFee"),
                                rules: [
                                  _vm.fieldIsRequired("inboundFee"),
                                  _vm.fieldIsNumber("inboundFee")
                                ]
                              },
                              model: {
                                value: _vm.curUpc.inboundFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.curUpc,
                                    "inboundFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "curUpc.inboundFee"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs2: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("outboundFee"),
                                rules: [
                                  _vm.fieldIsRequired("outboundFee"),
                                  _vm.fieldIsNumber("outboundFee")
                                ]
                              },
                              model: {
                                value: _vm.curUpc.outboundFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.curUpc,
                                    "outboundFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "curUpc.outboundFee"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs2: "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: _vm.$t("storageFee"),
                                rules: [
                                  _vm.fieldIsRequired("storageFee"),
                                  _vm.fieldIsNumber("storageFee")
                                ]
                              },
                              model: {
                                value: _vm.curUpc.storageFee,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.curUpc,
                                    "storageFee",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "curUpc.storageFee"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "" } },
                          [
                            _c("v-text-field", {
                              attrs: { label: _vm.$t("upc") },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.insertUpc.apply(null, arguments)
                                }
                              },
                              model: {
                                value: _vm.curUpc.upc,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.curUpc,
                                    "upc",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "curUpc.upc"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs1: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  icon: "",
                                  flat: "",
                                  color: "primary"
                                },
                                on: { click: _vm.insertUpc }
                              },
                              [_c("v-icon", [_vm._v("add")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs3: "", md3: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: _vm.unableModify,
                                  color: "primary",
                                  title: "importFile",
                                  loading: _vm.isUploading
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { dark: "", left: "" } },
                                  [_vm._v("cloud_upload")]
                                ),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("batchUpload")) +
                                    "\n              "
                                ),
                                _c("input", {
                                  staticClass: "hideInput",
                                  attrs: {
                                    type: "file",
                                    accept: ".csv,.xls,.xlsx"
                                  },
                                  on: {
                                    click: _vm.clearSelectionCache,
                                    change: _vm.uploadFile
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs2: "", md2: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: _vm.unableModify,
                                  color: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.exportTableData.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("export")) +
                                    "\n          "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-data-table", {
                      attrs: {
                        headers: _vm.pricingPlanHeaders,
                        items: _vm.pricingPlan.upcs,
                        "hide-actions": "",
                        "item-key": "upc"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(props.item.upc) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(props.item.description || "--") +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              !props.item.editMode
                                ? [
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.inboundFee) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.outboundFee) +
                                          "\n              "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.storageFee) +
                                          "\n              "
                                      )
                                    ])
                                  ]
                                : [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("inboundFee"),
                                            rules: [
                                              _vm.fieldIsRequired("inboundFee"),
                                              _vm.fieldIsNumber("inboundFee")
                                            ]
                                          },
                                          model: {
                                            value: props.item.inboundFee,
                                            callback: function($$v) {
                                              _vm.$set(
                                                props.item,
                                                "inboundFee",
                                                _vm._n(
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              )
                                            },
                                            expression: "props.item.inboundFee"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("outboundFee"),
                                            rules: [
                                              _vm.fieldIsRequired(
                                                "outboundFee"
                                              ),
                                              _vm.fieldIsNumber("inboundFee")
                                            ]
                                          },
                                          model: {
                                            value: props.item.outboundFee,
                                            callback: function($$v) {
                                              _vm.$set(
                                                props.item,
                                                "outboundFee",
                                                _vm._n(
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              )
                                            },
                                            expression: "props.item.outboundFee"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("storageFee"),
                                            rules: [
                                              _vm.fieldIsRequired("storageFee"),
                                              _vm.fieldIsNumber("inboundFee")
                                            ]
                                          },
                                          model: {
                                            value: props.item.storageFee,
                                            callback: function($$v) {
                                              _vm.$set(
                                                props.item,
                                                "storageFee",
                                                _vm._n(
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              )
                                            },
                                            expression: "props.item.storageFee"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-xs-center" },
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: {
                                        "justify-center": "",
                                        "align-center": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            "ml-1": "",
                                            "mt-2": "",
                                            md3: "",
                                            xs3: ""
                                          }
                                        },
                                        [
                                          _c("v-checkbox", {
                                            model: {
                                              value:
                                                props.item.associatedDiscount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.item,
                                                  "associatedDiscount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.item.associatedDiscount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              props.item.editMode
                                ? [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: "",
                                              small: "",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.$set(
                                                  props.item,
                                                  "editMode",
                                                  false
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("check")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: "",
                                              small: "",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.cancelEdit(
                                                  props.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("cancel")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                : [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled: _vm.unableModify,
                                              color: "primary",
                                              flat: "",
                                              small: "",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.editItem(props.item)
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled: _vm.unableModify,
                                              color: "primary",
                                              flat: "",
                                              small: "",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.pricingPlan.upcs.splice(
                                                  props.index,
                                                  1
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { "mt-3": "" } },
                      [
                        _c("v-textarea", {
                          staticClass: "thinBox",
                          attrs: {
                            label: _vm.$t("note"),
                            outline: "",
                            rows: "1",
                            counter: "200"
                          },
                          model: {
                            value: _vm.pricingPlan.note,
                            callback: function($$v) {
                              _vm.$set(_vm.pricingPlan, "note", $$v)
                            },
                            expression: "pricingPlan.note"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.isShowPricingPlanPopup,
          callback: function($$v) {
            _vm.isShowPricingPlanPopup = $$v
          },
          expression: "isShowPricingPlanPopup"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6edc2ae2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6edc2ae2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PricingPlan.vue
// module id = null
// module chunks = 